import previewSaga from './sagas/previewSaga'
import publishSaga from './sagas/publishSaga'
import resetFormSaga from './sagas/resetFormSaga'

export default [
  previewSaga,
  publishSaga,
  resetFormSaga, // Workaround for bug https://github.com/marmelab/react-admin/issues/2129
]
